import React from "react";
import { labelHelper } from "../../../../helpers/labelHelper";
import { deepClone } from "../../../../helpers/objectHelper";
import PersonIcon from "@material-ui/icons/Person";
import BusinessIcon from "@material-ui/icons/Business";
import ListIcon from "@material-ui/icons/List";
import { SectionTagsHelpInfo } from "../TagGroups/SectionTagHelpInfo";
import PublicIcon from "@material-ui/icons/Public";
import EventIcon from "@material-ui/icons/Event";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import ReceiptIcon from "@material-ui/icons/Receipt";

const personTags = {
  groupName: "PersonTags",
  description: "ExtractTagsWithPersonData",
  icon: <PersonIcon />,
  tooltipComponent: null,
  tags: [
    { editFacade: "", name: "PersonFirstName", labelName: "", group: "PersonTags", tag: "[PersonFirstName]" },
    { editFacade: "", name: "PersonLastName", labelName: "", group: "PersonTags", tag: "[PersonLastName]" },
    { editFacade: "", name: "PersonAddress1", labelName: "", group: "PersonTags", tag: "[PersonAddress1]" },
    { editFacade: "", name: "PersonAddress2", labelName: "", group: "PersonTags", tag: "[PersonAddress2]" },
    { editFacade: "", name: "PersonCity", labelName: "", group: "PersonTags", tag: "[PersonCity]" },
    { editFacade: "", name: "PersonCountry", labelName: "", group: "PersonTags", tag: "[PersonCountry]" },
    { editFacade: "", name: "PersonDepartment", labelName: "", group: "PersonTags", tag: "[PersonDepartment]" },
    { editFacade: "", name: "PersonPassword", labelName: "", group: "PersonTags", tag: "[PersonPassword]" },
    { editFacade: "", name: "PersonTitle", labelName: "", group: "PersonTags", tag: "[PersonTitle]" },
    { editFacade: "", name: "PersonZip", labelName: "", group: "PersonTags", tag: "[PersonZip]" },
    { editFacade: "", name: "PersonTelephone1", labelName: "", group: "PersonTags", tag: "[PersonTelephone1]" },
    { editFacade: "", name: "PersonTelephone2", labelName: "", group: "PersonTags", tag: "[PersonTelephone2]" },
    { editFacade: "", name: "PersonTelephone3", labelName: "", group: "PersonTags", tag: "[PersonTelephone3]" },
  ],
};

const companyTags = {
  groupName: "CompanyTags",
  description: "ExtractTagsWithCompanyData",
  icon: <BusinessIcon />,
  tooltipComponent: null,
  tags: [
    { editFacade: "", name: "CompanyName", labelName: "", group: "CompanyTags", tag: "[CompanyName]" },
    { editFacade: "", name: "CompanyAddress1", labelName: "", group: "CompanyTags", tag: "[CompanyAddress1]" },
    { editFacade: "", name: "CompanyAddress2", labelName: "", group: "CompanyTags", tag: "[CompanyAddress2]" },
    { editFacade: "", name: "CompanyZip", labelName: "", group: "CompanyTags", tag: "[CompanyZip]" },
    { editFacade: "", name: "CompanyCountry", labelName: "", group: "CompanyTags", tag: "[CompanyCountry]" },
    { editFacade: "", name: "CompanyOrgno", labelName: "", group: "CompanyTags", tag: "[CompanyOrgno]" },
    { editFacade: "", name: "CompanyEmail", labelName: "", group: "CompanyTags", tag: "[CompanyEmail]" },
    { editFacade: "", name: "CompanyTelephone1", labelName: "", group: "CompanyTags", tag: "[CompanyTelephone1]" },
    { editFacade: "", name: "CompanyTelephone2", labelName: "", group: "CompanyTags", tag: "[CompanyTelephone2]" },
    { editFacade: "", name: "CompanyTelephone3", labelName: "", group: "CompanyTags", tag: "[CompanyTelephone3]" },
    { editFacade: "", name: "CompanyCity", labelName: "", group: "CompanyTags", tag: "[CompanyGLN]" },
  ],
};
const sectionTags = {
  groupName: "SectionTags",
  description: "ExtractTagsWithSectionData",
  icon: <ListIcon />,
  tooltipComponent: <SectionTagsHelpInfo />,
  tags: [
    { editFacade: "", name: "PersonDetails", labelName: "", group: "SectionTags", tag: "[PersonDetails]" },
    { editFacade: "", name: "CompanyDetails", labelName: "", group: "SectionTags", tag: "[CompanyDetails]" },
    { editFacade: "", name: "PersonCompanyDetails", labelName: "", group: "SectionTags", tag: "[PersonCompanyDetails]" },
    { editFacade: "", name: "InvoiceDetails", labelName: "", group: "SectionTags", tag: "[InvoiceDetails]" },
    { editFacade: "", name: "Questions", labelName: "", group: "SectionTags", tag: "[Questions]" },
    { editFacade: "", name: "OrderRows", labelName: "", group: "SectionTags", tag: "[OrderRows]" },
    { editFacade: "", name: "RepeatableStart", labelName: "", group: "SectionTags", tag: "[RepeatableStart]" },
    { editFacade: "", name: "RepeatableEnd", labelName: "", group: "SectionTags", tag: "[RepeatableEnd]" },
  ],
};
const eventTags = {
  groupName: "EventTags",
  description: "ExtractTagsWithEvenntData",
  icon: <EventIcon />,
  tooltipComponent: null,
  tags: [
    { editFacade: "", name: "EventId", labelName: "", group: "EventTags", tag: "[EventId]" },
    { editFacade: "", name: "EventName", labelName: "", group: "EventTags", tag: "[EventName]" },
    { editFacade: "", name: "EventStartDate", labelName: "", group: "EventTags", tag: "[EventStartDate]" },
    { editFacade: "", name: "EventStartDate", labelName: "", group: "EventTags", tag: "[EventEndDate]" },
    { editFacade: "", name: "EventPrice", labelName: "", group: "EventTags", tag: "[EventPrice]" },
    { editFacade: "", name: "EventVenue", labelName: "", group: "EventTags", tag: "[EventVenue]" },
    { editFacade: "", name: "EventCity", labelName: "", group: "EventTags", tag: "[EventCity]" },
    { editFacade: "", name: "EventDescription", labelName: "", group: "EventTags", tag: "[EventDescription]" },
    { editFacade: "", name: "EventMax", labelName: "", group: "EventTags", tag: "[EventAvailable]" },
  ],
};

const invoiceCompanyTags = {
  groupName: "InvoiceCompanyTags",
  description: "ExtractTagsWithInvoiceData",
  icon: <ReceiptIcon />,
  tooltipComponent: null,
  tags: [
    { editFacade: "", name: "InvoiceCompanyName", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyName]" },
    { editFacade: "", name: "InvoiceCompanyAddress1", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyAddress1]" },
    { editFacade: "", name: "InvoiceCompanyAddress2", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyAddress2]" },
    { editFacade: "", name: "InvoiceCompanyZip", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyZip]" },
    { editFacade: "", name: "InvoiceCompanyCountry", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyCountry]" },
    { editFacade: "", name: "InvoiceCompanyOrgno", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyOrgno]" },
    { editFacade: "", name: "InvoiceCompanyEmail", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyEmail]" },
    { editFacade: "", name: "InvoiceCompanyTelephone1", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyTelephone1]" },
    { editFacade: "", name: "InvoiceCompanyCity", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyCity]" },
    { editFacade: "", name: "InvoiceCompanyGLN", labelName: "", group: "InvoiceCompanyTags", tag: "[InvoiceCompanyGLN]" },
  ],
};

const orderTags = {
  groupName: "OrderTags",
  description: "ExtractTagsWithOrderData",
  icon: <ShoppingCartIcon />,
  tooltipComponent: null,
  tags: [
    { editFacade: "", name: "RegistrationType", labelName: "", group: "OrderTags", tag: "[RegistrationType]" },
    { editFacade: "", name: "BadgeNo", labelName: "", group: "OrderTags", tag: "[BadgeNo]" },
    { editFacade: "", name: "OrderSource", labelName: "", group: "OrderTags", tag: "[OrderSource]" },
    { editFacade: "", name: "OrderBrowser", labelName: "", group: "OrderTags", tag: "[OrderBrowser]" },
    { editFacade: "", name: "OrderRemoteAddr", labelName: "", group: "OrderTags", tag: "[OrderRemoteAddr]" },
  ],
};

const orgTags = {
  groupName: "OrganizationTags",
  description: "ExtractTagsWithOrgData",
  icon: <PublicIcon />,
  tooltipComponent: null,
  tags: [
    { editFacade: "", name: "OrganizationName", labelName: "", group: "OrganizationTags", tag: "[OrganizationName]" },
    { editFacade: "", name: "OrganizationOrgno", labelName: "", group: "OrganizationTags", tag: "[OrganizationOrgno]" },
  ],
};
const tagDictionary = [sectionTags, personTags, companyTags, invoiceCompanyTags, eventTags, orderTags, orgTags];

export function createTagDictionaryForReplace(tags) {
  const editorTags = [];
  tagDictionary.map((t) => {
    t.tags.map((ct) => {
      editorTags.push({
        tag: ct.tag,
        editFacade: `[${ct.name}]`,
      });
    });
  });
  return editorTags;
}

export function createTagDictionary(tags) {
  const editorTags = [];
  tagDictionary.map((t) => {
    const tagGroup = deepClone(t);
    const newTags = [];
    tagGroup.tags.map((ct) => {
      newTags.push({
        ...ct,
        labelName: ct.name == "RepeatableEnd" || ct.name == "RepeatableStart" ? ct.name : labelHelper.getLabel(ct.name),
        /*      description: labelHelper.getLabel(ct.description), */
        editFacade: `[${ct.name}]`,
      });
    });
    tagGroup.tags = newTags;
    editorTags.push(tagGroup);
  });
  return editorTags;
}
